import { Column, Editing, Item, RequiredRule, Toolbar } from 'devextreme-react/data-grid';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, Button as RxButton } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid';
import api from '../../../services/api-configuration';
import { ButtonOnExporting } from '../../../utils/DataGridExporter';
import useFormatMessage from '../../../utils/useFormatMessage';

export const IlceTanimlari = () => {
    const { t } = useFormatMessage();
    const [dataSources, setDataSources] = useState([]);
    const [cities, setCities] = useState([]);
    const ref = useRef();
    const mountedRef = useRef(true);

    let skipValidationCheck = false;

    useEffect(() => {
        fetchData();
        fetchCities();
        return () => {
            mountedRef.current = false;
        };
    }, []);

    const fetchData = async () => {
        try {
            const response = await api.post("/district/getAll");
            if (mountedRef.current) {
                let all_data = response.data.data || []
                setDataSources(
                    all_data.filter((item) => (item.id !== 4))
                );
            }
        } catch (error) {
            toast.error("Hata oluştu");
            console.error("Error fetching districts:", error);
        }
    };

    const fetchCities = async () => {
        try {
            const response = await api.post("/city/getAll");
            if (mountedRef.current) {
                setCities(response.data.data || []);
            }
        } catch (error) {
            console.error("Error fetching cities:", error);
        }
    };

    const addModel = async (data, e) => {
        data.create_user_id = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'))

        try {
            const response = await api.post("/district/create", data);
            if (response.status === 200) {
                skipValidationCheck = true;
                toast.success(t("Ekleme başarılı"));
                fetchData();
            }
        } catch (error) {
            console.error("Error adding district:", error);
            let errorMessage = error.response?.data?.error || "";
            toast.error(errorMessage || "Hata oluştu");
        }
    };

    const updateModel = async (e, data) => {
        const employeeId = parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'));
        const body = {
            ...data.oldData,
            ...data.newData,
            update_user_id: employeeId,
            update_date: new Date().toISOString()
        };
        try {
            const response = await api.post("/district/update", body);
            if (response.status === 200) {
                skipValidationCheck = true;
                toast.success(t("Güncelleme başarılı"));
                fetchData();
            }
        } catch (error) {
            console.error("Error updating district:", error);
            let errorMessage = error.response?.data?.error || "";
            toast.error(errorMessage || "Hata oluştu");
        }
    };

    const onRowValidating = (e) => {
        if (e.brokenRules.length === 0) {
            if (skipValidationCheck) {
                e.isValid = true;
                skipValidationCheck = false;
                return;
            }

            e.isValid = false;
            if (!e.oldData) {
                addModel(e.newData, e);
            } else {
                updateModel(e, e);
            }
        }
    };

    return (
        <>
            <Breadcrumb current={t("İlçe Tanımları")} />
            <Card className="p-4">
                <DatagridCustom
                    dataSource={dataSources}
                    reff={ref}
                    onRowValidating={onRowValidating}
                    onInitNewRow={(e) => {
                        e.data.is_active = true;
                        e.component.__addingStart = true;
                    }}
                >
                    <Editing
                        mode="row"
                        popup={{
                            title: t("Yeni İlçe Tanımı"),
                            showTitle: true,
                            width: 700,
                            height: "auto",
                        }}
                        allowUpdating
                        allowAdding
                        useIcons
                    />
                    <Column dataField="city_id" caption={t("Şehir")}
                        lookup={{
                            dataSource: cities,
                            valueExpr: "id",
                            displayExpr: "city_name"
                        }}
                    >
                        <RequiredRule />
                    </Column>
                    <Column dataField="district_code" caption={t("İlçe Kodu")} selectedFilterOperation='contains' alignment='center'>
                        {/* <RequiredRule /> */}
                    </Column>
                    <Column dataField="district_name" caption={t("İlçe Adı")} selectedFilterOperation='contains' alignment='center'>
                        <RequiredRule />
                    </Column>
                    <Column dataField="is_active" caption={t("Aktif")} dataType="boolean" selectedFilterOperation='contains' alignment='center'>
                        <RequiredRule />
                    </Column>

                    <Toolbar>
                        <Item name="addRowButton" />
                        <Item location="after">
                            <RxButton
                                color="light"
                                outline
                                onClick={fetchData}
                                style={{
                                    paddingInline: "10px",
                                    border: "1px solid #ddd"
                                }}
                            >
                                <i className="fa fa-refresh"></i>
                            </RxButton>
                            &nbsp;
                            <RxButton
                                className='btn btn-success'
                                style={{
                                    color: "white",
                                    paddingInline: "10px",
                                }}
                                onClick={(e) => ButtonOnExporting(e, ref, "İlçe Tanımları")}>
                                <i className="fa fa-file-excel-o"></i>
                            </RxButton>
                        </Item>
                    </Toolbar>
                </DatagridCustom>
            </Card>
        </>
    );
};